import { render, staticRenderFns } from "./Warehousing.vue?vue&type=template&id=5476e362&scoped=true&"
import script from "./Warehousing.vue?vue&type=script&lang=js&"
export * from "./Warehousing.vue?vue&type=script&lang=js&"
import style0 from "./Warehousing.vue?vue&type=style&index=0&id=5476e362&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5476e362",
  null
  
)

export default component.exports